module.exports = __webpack_public_path__ + "static/img/4.23ec69e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/front/threeD/4/4.png
// module id = 8No7
// module chunks = 2